import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 🏆 Défi étoiles de la semaine : objectif hebdo + surprise bonus choisie par papa.
export default function WeeklyChallenge({ token, onStars }) {
  const [c, setC] = useState(null);
  const [won, setWon] = useState(null);
  const load = useCallback(() => axios.get(`${API}/cataley/public/${token}/challenge`).then((r) => setC(r.data)).catch(() => setC(null)), [token]);
  useEffect(() => { load(); }, [load]);
  if (!c || !c.enabled) return null;

  const claim = async () => {
    try { const r = await axios.post(`${API}/cataley/public/${token}/challenge/claim`); setWon(r.data); if (r.data.stars != null) onStars?.(r.data.stars); load(); }
    catch { /* ignore */ }
  };

  return (
    <div className={`rounded-3xl p-4 shadow-sm ${c.reached ? "bg-gradient-to-br from-amber-200 via-yellow-100 to-orange-100" : "bg-white"}`} data-testid="cataley-challenge">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold text-stone-500">🏆 Défi étoiles de la semaine</div>
        <div className="text-xs font-bold text-amber-600" data-testid="challenge-progress">{c.earned} / {c.target} ⭐</div>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-stone-100">
        <div className="h-full rounded-full bg-gradient-to-r from-amber-400 to-orange-500 transition-all" style={{ width: `${c.percent}%` }} />
      </div>
      {!c.reached && <p className="mt-2 text-xs text-stone-600">Encore <b>{c.remaining}</b> étoile{c.remaining > 1 ? "s" : ""} à gagner en jouant pour débloquer la surprise de papa 🎁</p>}
      {c.reached && !c.claimed && (
        <button onClick={claim} data-testid="challenge-claim" className="mt-3 w-full rounded-full bg-rose-500 py-3 text-base font-black text-white shadow hover:bg-rose-600 active:scale-95">
          🎁 Objectif atteint ! Ouvrir la surprise
        </button>
      )}
      {(won || (c.reached && c.claimed)) && (
        <div className="mt-3 rounded-2xl bg-white/80 p-3 text-center" data-testid="challenge-surprise">
          <div className="text-3xl">🎉</div>
          <div className="font-black text-stone-800">{won?.surprise || c.surprise}</div>
          {c.bonus_stars > 0 && <div className="text-xs font-semibold text-amber-700">+{c.bonus_stars} étoiles bonus{won?.claimed ? " ajoutées !" : ""}</div>}
          <div className="mt-1 text-[11px] text-stone-500">Nouveau défi lundi prochain !</div>
        </div>
      )}
    </div>
  );
}
